import { useEffect, useRef } from 'react';

// Zavírání klepnutím na pozadí: jen když začalo (mousedown / touchstart) i skončilo (click) na pozadí.
// Označení textu v poli, jehož tah skončí mimo okno, tak dialog nezavře.
export function usePozadi(onZavrit) {
  const zacatekNaPozadi = useRef(false);
  const zacni = e => { zacatekNaPozadi.current = e.target === e.currentTarget; };
  return {
    onMouseDown: zacni,
    onTouchStart: zacni,
    onClick: e => {
      const ok = zacatekNaPozadi.current && e.target === e.currentTarget;
      zacatekNaPozadi.current = false;
      if (ok) onZavrit();
    },
  };
}

// Esc volá `onEsc` (jen nejvyšší otevřený dialog – poslední zaregistrovaný).
const zasobnikEsc = [];
export function useEsc(onEsc) {
  const ref = useRef(onEsc);
  ref.current = onEsc;
  useEffect(() => {
    const id = {};
    zasobnikEsc.push(id);
    const h = e => { if (e.key === 'Escape' && zasobnikEsc[zasobnikEsc.length - 1] === id) ref.current(); };
    document.addEventListener('keydown', h);
    return () => { document.removeEventListener('keydown', h); zasobnikEsc.splice(zasobnikEsc.indexOf(id), 1); };
  }, []);
}
